import { startAccounts } from './account.js';
void startAccounts();
